import React, {Component} from 'react';
import * as moment from 'moment';
import {Input, Button, Card, Row, Col, Form, Select, DatePicker, Divider, Alert, Icon, Modal} from 'antd';

import Map from '../../Map';
import Document from './Document';

const {Option, OptGroup} = Select;
const {Item: FormItem} = Form;
const {confirm} = Modal;

class Property extends Component {
    render() {
        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 8 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 16 },
            },
        };
        const tailFormItemLayout = {
            wrapperCol: {
                xs: {
                    span: 24,
                    offset: 0,
                },
                sm: {
                    span: 18,
                    offset: 8,
                },
            },
        };

        const { getFieldDecorator } = this.props.form;
        const {onSubmit, onPostcodeChange, property, form, contractors, onRetire, onUpload, onDelete, generateUrl} = this.props;
        const isEdit = () => {
            return property && !property.draft;
        };
        const isRetired = () => {
            return property && property.isRetired;
        };
        const getDefaultVal = (key) => {
            return (property && property[key]) || '';
        };
        const dateVal = (field, defaultVal = moment()) => {
            if (!isEdit()) {
                return moment();
            }
            const date = property[field] && property[field].date;
            return date ? moment(date, 'YYYY-MM-DD') : defaultVal;
        };
        const handleSubmit = (e) => {
            e.preventDefault();
            return form.validateFieldsAndScroll((err, values) => {
                if (err) {
                    return;
                }
                const dateFields = [
                    'certificate_next_due',
                    'service_next_due'
                ];
                dateFields.forEach(field => {
                    if (values[field]) {
                        values = {...values, [field]: values[field].format('DD/MM/YYYY')}
                    }
                });
                return onSubmit(values);
            });
        };
        const title = () => (
            <div style={{lineHeight: '35px'}}>
                <span>{isEdit() ? 'Edit': 'New'} Property</span>
            </div>
        );

        const onCancel = (e) => {
            return this.props.onCancel(e);
        };

        const makeProperCase = text => {
            return text.toLowerCase()
                .split(' ')
                .map(s => s.charAt(0).toUpperCase() + s.substring(1))
                .join(' ')
        };

        const renderForm = () => {
            return (
                <Form onSubmit={handleSubmit}>
                    <FormItem
                        hasFeedback={!isRetired()}
                        {...formItemLayout}
                        label={(
                            <span>Property Ref No</span>
                        )}
                    >
                        {getFieldDecorator('registration_no', {
                            initialValue: getDefaultVal('registration_no'),
                            rules: [{ required: true, message: 'Please input your Property Ref No', whitespace: true }],
                        })(
                            <Input disabled={isRetired()}/>
                        )}
                    </FormItem>

                    <FormItem
                        hasFeedback={!isRetired()}
                        {...formItemLayout}
                        label="Customer Title"
                    >
                        {getFieldDecorator('title', {
                            initialValue: getDefaultVal('title') || 'Mr',
                            rules: [{ message: 'Please input Customer Title', whitespace: true }],
                        })(
                            <Select disabled={isRetired()}>
                                <Option value="Mr">Mr</Option>
                                <Option value="Mrs">Mrs</Option>
                                <Option value="Ms">Ms</Option>
                                <Option value="Miss">Miss</Option>
                                <Option value="Dr">Dr</Option>
                                <Option value="Rev">Rev</Option>
                            </Select>
                        )}
                    </FormItem>

                    <FormItem
                        hasFeedback={!isRetired()}
                        {...formItemLayout}
                        label="Customer First Name"
                    >
                        {getFieldDecorator('first_name', {
                            initialValue: getDefaultVal('first_name'),
                            normalize: makeProperCase,
                            rules: [{message: 'Please input Customer First Name' }],
                        })(
                            <Input disabled={isRetired()}/>
                        )}
                    </FormItem>

                    <FormItem
                        hasFeedback={!isRetired()}
                        {...formItemLayout}
                        label="Customer Surname"
                    >
                        {getFieldDecorator('surname', {
                            initialValue: getDefaultVal('surname'),
                            normalize: makeProperCase,
                            rules: [{message: 'Please input Customer Surname' }],
                        })(
                            <Input disabled={isRetired()} />
                        )}
                    </FormItem>

                    <FormItem
                        hasFeedback={!isEdit()}
                        {...formItemLayout}
                        label="House Name or Number"
                    >
                        {getFieldDecorator('house_no', {
                            initialValue: getDefaultVal('house_no'),
                            rules: [{ required: !isEdit(), message: 'Please input Customer House Name or Number' }],
                        })(
                            <Input disabled={isEdit() || isRetired()}/>
                        )}
                    </FormItem>

                    <FormItem
                        hasFeedback={!isEdit()}
                        {...formItemLayout}
                        label="Street/Road"
                    >
                        {getFieldDecorator('street', {
                            initialValue: getDefaultVal('street'),
                            rules: [{ required: !isEdit(), message: 'Please input Street' }],
                        })(
                            <Input disabled={isEdit() || isRetired()}/>
                        )}
                    </FormItem>

                    <FormItem
                        hasFeedback={!isEdit()}
                        {...formItemLayout}
                        label="District"
                    >
                        {getFieldDecorator('district', {
                            initialValue: getDefaultVal('district'),
                            rules: [{ required: !isEdit(), message: 'Please input District' }],
                        })(
                            <Input disabled={isEdit() || isRetired()}/>
                        )}
                    </FormItem>

                    <FormItem
                        hasFeedback={!isEdit()}
                        {...formItemLayout}
                        label="Town/City"
                    >
                        {getFieldDecorator('city', {
                            initialValue: getDefaultVal('city'),
                            rules: [{ required: !isEdit(), message: 'Please input City/Town' }],
                        })(
                            <Input disabled={isEdit() || isRetired()}/>
                        )}
                    </FormItem>

                    <FormItem
                        hasFeedback={!isEdit()}
                        {...formItemLayout}
                        label="County"
                    >
                        {getFieldDecorator('county', {
                            initialValue: getDefaultVal('county'),
                            rules: [{ required: !isEdit(), message: 'Please input County' }],
                        })(
                            <Input disabled={isEdit() || isRetired()}/>
                        )}
                    </FormItem>

                    <FormItem
                        hasFeedback={!isEdit()}
                        {...formItemLayout}
                        label="Postcode"
                    >
                        {getFieldDecorator('postcode', {
                            initialValue: getDefaultVal('postcode'),
                            normalize: value => {
                                if (!value) return "";
                                return value.replace(/[ ]+/g, '')
                                    .replace(/([A-Za-z]{1,2}[0-9Rr][0-9A-Za-z]?)([0-9][ABD-HJLNP-UW-Zabd-hjlnp-uw-z]{2})/, "$1 $2")
                                    .toUpperCase();
                            },
                            rules: [
                                { pattern: '[A-Za-z]{1,2}[0-9Rr][0-9A-Za-z]? [0-9][ABD-HJLNP-UW-Zabd-hjlnp-uw-z]{2}', message: 'Invalid post code', transform: value => {
                                    return value.replace(/[ ]+/g, '')
                                        .replace(/([A-Za-z]{1,2}[0-9Rr][0-9A-Za-z]?)([0-9][ABD-HJLNP-UW-Zabd-hjlnp-uw-z]{2})/, "$1 $2");
                                }},
                                { required: !isEdit(), message: 'Please input your post code', whitespace: true }
                            ]
                        })(
                            <Input disabled={isEdit() || isRetired()} onChange={() => setTimeout(() => onPostcodeChange(form.getFieldValue('postcode')))}/>
                        )}
                    </FormItem>

                    <FormItem
                        hasFeedback
                        {...formItemLayout}
                        label="Phone Number"
                    >
                        {getFieldDecorator('phone_no', {
                            initialValue: getDefaultVal('phone_no'),
                            rules: [
                                { pattern: /\d{11}$/, message: 'Invalid phone number' },
                                { message: 'Please input your phone number!', whitespace: true }
                            ],
                        })(
                            <Input disabled={isRetired()} />
                        )}
                    </FormItem>

                    <FormItem
                        hasFeedback
                        {...formItemLayout}
                        label="E-mail"
                    >
                        {getFieldDecorator('email', {
                            initialValue: getDefaultVal('email'),
                            rules: [{
                                type: 'email', message: 'The input is not valid E-mail!',
                            }, {
                                message: 'Please input your E-mail!', whitespace: true,
                            }],
                        })(
                            <Input disabled={isRetired()}/>
                        )}
                    </FormItem>

                    <FormItem
                        hasFeedback={!isRetired()}
                        {...formItemLayout}
                        label="Next Due Landlords Safety Certificate"
                    >
                        {getFieldDecorator('certificate_next_due', {
                            initialValue: dateVal('certificate_next_due'),
                            rules: [{
                                type: 'object', required: true, message: 'Invalid Certificate Next Due', whitespace: true,
                            }],
                        })(
                            <DatePicker disabled={isRetired()} format='DD/MM/YYYY'/>
                        )}
                    </FormItem>

                    <FormItem
                        hasFeedback={!isRetired()}
                        {...formItemLayout}
                        label="Next Due Service"
                    >
                        {getFieldDecorator('service_next_due', {
                            initialValue: dateVal('service_next_due'),
                            rules: [{
                                type: 'object', required: true, message: 'Invalid Service Next Due', whitespace: true,
                            }],
                        })(
                            <DatePicker disabled={isRetired()} format='DD/MM/YYYY'/>
                        )}
                    </FormItem>

                    <FormItem
                        hasFeedback={!isRetired()}
                        {...formItemLayout}
                        label="Responsible"
                    >
                        {getFieldDecorator('responsible', {
                            initialValue: getDefaultVal('responsible') ? getDefaultVal('responsible').id + '' : null,
                            rules: [{ message: 'Please select responsible person' }],
                        })(
                            <Select placeholder='Please select the responsible person' disabled={isRetired()}>
                                <Option value={null} key="0">DLO</Option>
                                <OptGroup label="Contractors">
                                    {contractors.map(b => (
                                        <Option value={'' + b.id} key={'c' + b.id}>{b.business_name}</Option>
                                    ))}
                                </OptGroup>
                            </Select>
                        )}
                    </FormItem>

                    { isRetired() ? null : (
                        <FormItem {...tailFormItemLayout}>
                            <Button size='large' onClick={onCancel} style={{marginRight: 10}}>Cancel</Button>
                            <Button size='large' type="primary" htmlType="submit">Submit</Button>
                        </FormItem>
                    )}
                </Form>
            )
        };
        const renderMap = () => (
            <Map {...this.props.location} />
        );

        const showConfirm = () => {
            confirm({
                title: 'Please confirm you wish to remove this property',
                content: '',
                onOk() {
                    return onRetire();
                },
                onCancel() {},
            });
        };
        return (
            <Card title={title()} loading={this.props.isFetching} bordered={false}>
                {isRetired() ? (
                    <Alert
                        style={{marginBottom: 15}}
                        message="Retired"
                        description="This property has been retired. All the fields are read only."
                        type="error"
                        showIcon
                    />
                ) : null}
                <Row gutter={16}>
                    <Col md={{span: 15}}>
                        {renderForm()}
                    </Col>
                    <Col md={{span: 9}}>
                        {isEdit() ? (
                            <Card style={{marginBottom: 10}}>
                                <p>
                                    <strong>Last Visit: </strong> {`${dateVal('last_visit', ' -')}`}
                                </p>
                                <p>
                                    <strong>Reason for Visit: </strong> {`${getDefaultVal('visit_reason') || ' -'}`}
                                </p>
                            </Card>
                        ) : null}
                        <Divider orientation="left">Property Location</Divider>
                        {renderMap()}
                        {isEdit() ? (
                            <div>
                                <Divider orientation="left">Documents</Divider>
                                <Document
                                    onUpload={onUpload}
                                    onDelete={onDelete}
                                    generateUrl={generateUrl}
                                    documents={property ? property.documents : []}
                                    uploadError={property ? property.uploadError: {}}
                                    disabled={isRetired() || !isEdit()}
                                />
                            </div>
                        ) : null}

                        {!isRetired() && isEdit() ? (
                            <div>
                                <Divider />
                                <Button size='large' type="danger" style={{width: '100%'}} onClick={showConfirm}>Retire This Property</Button>
                            </div>
                        ) : null}
                    </Col>
                </Row>
            </Card>
        );
    }
}

const WrappedForm = Form.create()(Property);
export default WrappedForm;


// WEBPACK FOOTER //
// ./resources/assets/js/components/provider/property/Property.js